export default __webpack_public_path__ + "static/media/altromPrivilegeLogo_fr.d37a8548.svg";